import { Controller } from "@hotwired/stimulus"

// Bloque "Payload" del panel de filtros de telemetrías (FIL, feedback
// 2026-09-20): armar N condiciones clave/operador/valor en UNA pasada del
// panel, sin aplicar entre medio.
//
// El server pinta las condiciones aplicadas + una fila vacía (alta sin JS) y
// un <template> con la misma fila y el marcador __INDEX__ en names e ids.
// "Añadir condición" clona la plantilla con el primer índice libre (los
// índices son los sufijos pk<i>/po<i>/pv<i> del query string y pueden tener
// huecos); "Quitar" saca la fila — una fila que no viaja, no filtra. Con una
// sola fila, quitar la vacía en vez de dejar el bloque sin filas.
//
// Los botones nacen ocultos (CSS) y se muestran al conectar: sin JS son
// inertes y no deben prometer nada.
export default class extends Controller {
  static targets = ["rows", "template", "row", "add"]
  static values = { max: { type: Number, default: 5 } }
  static classes = ["ready"]

  connect() {
    this.element.classList.add("tp-filter-panel__payload--ready")
    this.syncAdd()
  }

  add() {
    if (this.rowTargets.length >= this.maxValue) return

    const index = this.freeIndex()
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", String(index))
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.rowTargets.at(-1)?.querySelector("select, input")?.focus()
    this.syncAdd()
  }

  remove(event) {
    const row = event.currentTarget.closest("[data-v2--payload-conditions-target~='row']")
    if (!row) return

    if (this.rowTargets.length > 1) {
      row.remove()
    } else {
      for (const field of row.querySelectorAll("select, input")) field.value = ""
    }
    this.syncAdd()
  }

  // Primer índice sin usar, como el server (free_payload_index).
  freeIndex() {
    const used = new Set(this.rowTargets.map((row) => Number(row.dataset.index)))
    let index = 0
    while (used.has(index)) index += 1
    return index
  }

  syncAdd() {
    if (!this.hasAddTarget) return

    this.addTarget.disabled = this.rowTargets.length >= this.maxValue
  }
}
